import { __exports as DurationRecordSign } from "../../../../../_virtual/DurationRecordSign.mjs";
import { __require as requireConstants } from "../constants.mjs";
var hasRequiredDurationRecordSign;
function requireDurationRecordSign() {
  if (hasRequiredDurationRecordSign) return DurationRecordSign;
  hasRequiredDurationRecordSign = 1;
  Object.defineProperty(DurationRecordSign, "__esModule", { value: true });
  DurationRecordSign.DurationRecordSign = void 0;
  var constants_1 = requireConstants();
  function DurationRecordSign$1(record) {
    for (var _i = 0, TABLE_1_1 = constants_1.TABLE_1; _i < TABLE_1_1.length; _i++) {
      var key = TABLE_1_1[_i];
      if (record[key] < 0) {
        return -1;
      }
      if (record[key] > 0) {
        return 1;
      }
    }
    return 0;
  }
  DurationRecordSign.DurationRecordSign = DurationRecordSign$1;
  return DurationRecordSign;
}
export {
  requireDurationRecordSign as __require
};
